    <template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-10">
        <h2>{{ $t("navigations.importtoformlibrary") }}</h2>
        </div>
    </div>
    <div class="wrapper wrapper-content">
        <div class="ibox-content mb-1 px-3 py-2">
            <div class="row">
                <div class="col-lg-4">
                        <label class="mb-0">{{ $t("navigations.importtoformlibrary") }}</label>
                        <Multiselect
                            mode="multiple"
                            :searchable="true"  
                            trackBy="templateName"
                            v-model="selectedTemplateIds"
                            :placeholder="$t('navigations.select')"
                            :tag-placeholder="$t('navigations.selected')"
                            :selected-label="$t('navigations.selected')"
                            valueProp="templateId"
                            label="templateName"
                            :options="templateList"
                            :hideSelected="false"
                            :closeOnSelect="false"
                            class="multiselect-template-theme mr-0"
                        >
                            <template v-slot:option="{ option }">
                                {{ option.templateName }} ({{ option.version }})    
                            </template>
                        </Multiselect>
                    </div>
                    <span
                        type="button"
                        class="col-sm-12 col-lg-1 save_btn my-1 my-lg-0 mx-lg-1 align-self-end"
                        @click.prevent="ImportFun()"
                    >
                        {{ $t("navigations.import") }}
                    </span>
                </div>
            </div>
        </div>
    </template>
        
    <script src="./importtoformlibrary.js"></script>
    <style scoped>
    .multiselect-template-theme {
        --ms-option-bg-selected-pointed: rgb(210, 210, 210);
        --ms-option-bg-selected: rgb(210, 210, 210);
        --ms-option-color-selected: #000;
        --ms-option-color-selected-pointed: #000;
        --ms-radius: 0;
        --ms-line-height: 0.8;
        --ms-option-font-size: 0.8rem;
        --ms-font-size: 0.8rem;
    }
    </style>